import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { InputListsTest } from "./InputListsTest";
import {
  getChildPacketAdd,
  getChildPacket,
  getChildPacketSub,
} from "../../../actionsMethods/cashBookingMethods";
import pluse from "../../../assests/images/childpackagePluseIcon.svg";
import PropTypes from "prop-types";

import "./style.scss";

const childBaggageModal = ({
  setAllTotal,
  allTotal,
  data,
  form,
  handleCancel,
  id,
  setCalShow,
  childPacket,
}) => {
  const dispatch = useDispatch();
  const [isRemove, setisRemove] = useState(false);
  const [noofChild, setnoofChild] = useState(1);
  const [updateSate, setUpdateSate] = useState(true);

  const chidlPacket = useSelector((state) => state.childPacketReducer);

  let arrOfData = [...Array(+chidlPacket.val)];

  const getUpdateShipmentResponse = useSelector(
    (state) => state.appReducer.getUpdateShipmentReducer
  );

  useEffect(() => {
    dispatch(getChildPacket(1));
    form.setFieldsValue({
      noOfChildPacket: 1,
    });

    arrOfData.forEach((element, index) => {
      form.setFieldsValue({
        [`total${index}`]: 0,
        [`length${index}`]: 0,
        [`height${index}`]: 0,
        [`width${index}`]: 0,
      });
    });
  }, [getUpdateShipmentResponse?.fetching]);

  useEffect(() => {
    if (!isRemove) {
      setnoofChild(chidlPacket.val);
      const newarr = [];
      const data = [];
      for (let i = 0; i < chidlPacket.val; i++) {
        newarr.push(i);
        data.push({
          width: null,
          length: null,
          height: null,
          totalweight: null,
        });
      }

      form.setFieldsValue({
        fields: data,
      });
      handleCancel();
      setUpdateSate(!updateSate);
    } else {
      if (chidlPacket.val > noofChild) {
        const formdata = form.getFieldValue("fields");
        const data = chidlPacket.val - formdata?.length;

        for (let i = 0; i < data; i++) {
          formdata.push({
            width: null,
            length: null,
            height: null,
            totalweight: null,
          });
        }
        form.setFieldValue({
          fields: formdata,
        });
        setnoofChild(chidlPacket.val);
        setUpdateSate(!updateSate);
      } else {
        const formdata = form.getFieldValue("fields");
        const arr = [];
        for (let i = 0; i < chidlPacket.val; i++) {
          const newarr = formdata.find((item, index) => index === i);
          arr.push(newarr);
        }
        form.setFieldsValue({
          fields: arr,
        });
        setUpdateSate(!updateSate);
      }
    }
  }, [chidlPacket.val]);

  useEffect(() => {
    let formData = form.getFieldsValue();
    let totalWidth = calculateFunc(formData, "width");
    let totalHeight = calculateFunc(formData, "height");
    let totalLength = calculateFunc(formData, "lengt");
    let totalOfTotal = calculateFunc(formData, "totalweight");

    setAllTotal({ totalOfTotal, totalLength, totalWidth, totalHeight });
    setCalShow(false);
  }, [data, updateSate, childPacket]);

  const calculateFunc = (formData, keyName) => {
    let arrayofOb = formData.fields;
    let total = 0;
    for (let i in arrayofOb) {
      if (arrayofOb[i][keyName] !== null) {
        total =
          parseFloat(
            arrayofOb[i][keyName] === undefined ||
              arrayofOb[i][keyName] == "NaN"
              ? 0
              : arrayofOb[i][keyName]
          ) + total;
      }
    }
    return total;
  };

  const setFieldValue = (name) => {
    setisRemove(true);
    const formData = form.getFieldValue("fields");
    const newForm = formData.filter((item, index) => index !== name);

    form.setFieldsValue({
      fields: newForm,
    });

    dispatch(getChildPacketSub(name));
  };

  const handleAdd = () => {
    setisRemove(true);
    const formData = form.getFieldValue("fields");

    formData.push({
      width: null,
      length: null,
      height: null,
      totalweight: null,
    });

    form.setFieldsValue({
      fields: formData,
    });
    dispatch(getChildPacketAdd());
  };

  const handleChangeExternal = () => {
    setisRemove(true);
  };

  return (
    <div className="child-baggage-modal">
      <div className="child-baggage-modal-div">
        <h4 className="child-baggage-text">Child packets</h4>
        <div className="child-baggage-bottomLine"></div>
      </div>
      <InputListsTest
        form={form}
        setFieldValue={setFieldValue}
        lg={arrOfData.length > 1 ? 5 : 6}
        sm={12}
        md={10}
        checkNumbervalue={+chidlPacket.val}
        handleChange={handleChangeExternal}
        arrOfData={arrOfData}
      />
      {arrOfData.map((form, index) => (
        <div key={index} className="child-baggage-modal-inputList">
          <div>
            {index === arrOfData.length - 1 ? (
              <div className="child-baggage-modal-inputList-button">
                <Button
                  style={{
                    background: "none",
                    border: " 1px solid #2E77D0",
                    color: "#2E77D0",
                    width: "auto",
                  }}
                  // className="child-baggage-modal-inputList-button-style"
                  onClick={() => handleAdd()}
                  type="dashed"
                >
                  Add child packet{" "}
                  <img src={pluse} style={{ margin: "10px" }} />
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
      <Row className="child-baggage-totalVolume" id={id}>
        <Col sm={12} md={6} lg={6} className="child-baggage-totalVolume-col">
          Length : {allTotal.totalLength || 0} Cm
        </Col>
        <Col sm={12} md={6} lg={6} className="child-baggage-totalVolume-col">
          Width : {allTotal.totalWidth || 0} Cm
        </Col>
        <Col sm={12} md={6} lg={6} className="child-baggage-totalVolume-col">
          Height : {allTotal.totalHeight || 0} Cm
        </Col>
        <Col sm={12} md={6} lg={6} className="child-baggage-totalVolume-col">
          Total Volumetric : {allTotal.totalOfTotal?.toFixed(2) || 0} Kg
        </Col>
        <Col sm={12} md={12} lg={1}></Col>
      </Row>
    </div>
  );
};

childBaggageModal.propTypes = {
  setAllTotal: PropTypes.any,
  allTotal: PropTypes.object,
  data: PropTypes.string,
  form: PropTypes.form,
};
export default childBaggageModal;
